import React, { useEffect, useRef} from "react";
import { useNavigate } from "react-router-dom";
import icons from "../icons";
import APIUrls from "../services/APIUrls";
import { Link } from 'react-router-dom';
import {isValidWeakPassword, isValidStrongPassword, encodePassword} from "../services/Util.js";
import { getAxiosResponse, loginFunc, postAxiosResponse, provisioningApiGetRequest} from "../services/authApiRoutes/APImethods";
import  { useState } from "react";
import Select from 'react-select';
import $, { event } from "jquery";
import Constants from "../Constants";
import Cookies from 'universal-cookie';
import { useDispatch } from 'react-redux';
import { loginSessionDetail } from "../redux/reducers/LoginSessionSlice";
import useLogOut from "../services/customHook/UseLogout";
import { handleError } from "../services/authApiRoutes/APImethods";
import { logError } from "../services/authApiRoutes/APImethods";
import { newUserPasswordSchema } from "../ValidationSchema";


export default function CompleteProfile(props) {
    const navigate = useNavigate();
    const logOut = useLogOut();

    const [strongPassword,setStrongPassword]=useState(false)
    const [verifyPassword,setVerifyPassword]=useState({});
    const [errors,setErrors] = useState({});
    const [weakPasswordStatus,setWeakPasswordStatus]=useState(false)
    const [status,setStatus]=useState(false);
    const [passwordStatus,setPasswordStatus]=useState(false)
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [incorrectOldPassword, setIncorrectOldPassword] = useState("");
    const focusRef = useRef();
    const params = new URLSearchParams(window.location.search);
    const id = params.get('id');
    const [locales, setLocales] = useState([]);
    const [timeZones, setTimeZones] = useState([]);
    const [selectedLocale, setSelectedLocale] = useState("");
    const [selectedTimeZone, setSelectedTimeZone] = useState("");
    const ssoUserEmail = localStorage.getItem('ssoUserEmail');
    const [user,setUser]=useState("")
    const [errorMessage,setErrorMessage]=useState("")
    const cookies = new Cookies();
  const [loginErrorMessage, setLoginErrorMessage] = useState("")
  const [invalidPassord,setInvalidPassword]=useState(false)
  const [viewName,setViewName]=useState(Constants.VIEW_NAME)
  const dispatch = useDispatch();
    const navigateToLogin = () => {
      setStatus(false)
      setPasswordStatus(false)
      logOut()
    };
    useEffect(() => {
      document.body.classList.remove("color-contrast");
      focusRef.current.focus();
       $(document).on("click","#change-pass",function() {
        setTimeout(function() { 
          if($("#currentPassword").hasClass('error-alert')){
            $('#currPass').trigger('focus')
          }
          else{
            $('#newPass').trigger('focus')
          }
        },2500);
      });
    }, []);


  useEffect(()=>{
   if(user){
    setSelectedLocale({value:user.locale,label:user.locale})
    setSelectedTimeZone({id:user.timeZone,label:user.timeZone})
   }
  },[user])

    
    const passwordCheck=(event)=>{
        let password=event?.target?.value
        setWeakPasswordStatus(isValidWeakPassword(password))
        setStrongPassword(isValidStrongPassword(password))
        if(isValidStrongPassword(password)){
            setWeakPasswordStatus(false)
        }
        setVerifyPassword({...verifyPassword,'password':password})
        setNewPassword(password);
    }

    const isVerifyPassword=(event)=>{
        let confirmPassword=event?.target?.value
        setVerifyPassword({...verifyPassword,'confirmPassword':confirmPassword})
        setConfirmPassword(confirmPassword);
    }

    useEffect(()=>{
      getAxiosResponse(APIUrls.UNAUTHENTICATED_VERIFY_NEWUSER_API+`?id=${id}`).then(res=>{
        if(res?.data?.data !==undefined){ 
        setUser(res?.data?.data)
        }else{
          setErrorMessage(Constants.VERIFY_NEW_USER_ERROR_MESSAGE)
        }
      
      }).catch(err=>{
        handleError(err)
      })
    },[id])
  
    const currentPassword = (event) => {
      setIncorrectOldPassword("")
      let oldPass = event.target.value;
      setOldPassword(oldPass);
      setVerifyPassword({...verifyPassword,'currentPassword':oldPass})
    }


    const onFormSubmit = (event) =>{
      event.preventDefault()
      let data=verifyPassword;
      try {
          newUserPasswordSchema.validateSync(data, {abortEarly: false});
          let body = {
              userId: user.userId,
              password: encodePassword(data.password),
              confirmPassword: encodePassword(data.confirmPassword),
              oldPassword: oldPassword,
              random: user?.random,
              encrypted: true
          }
          params.set("localeCode", selectedLocale.value);
          params.set("tzCode", selectedTimeZone.id);
          postAxiosResponse(APIUrls.UNAUTHENTICATED_VERIFY_NEWUSER_API + "?" + params.toString(), body).then(res => {
              if (viewName !== res?.data?.data?.viewName) {
                  setInvalidPassword(false)
                  loginFunc({email: user?.email, password: data?.confirmPassword}).then(response => {
                      if (response.data.msg === "login successful") {
                          var userInfo = response.data.userInfo.data
                          cookies.set('userEmail', userInfo.email, {path: '/'});
                          cookies.set('i18nextLng', userInfo.locale, {path: '/'});
                          dispatch(loginSessionDetail(userInfo))
                          localStorage.setItem('role', JSON.stringify(userInfo.role));
                          if (JSON.stringify(userInfo.role).includes("ROLE_CUSTOMER_REVIEWER") && (JSON.stringify(userInfo.role.length) == '1')) {
                              navigate("/task/all");
                          } else {
                              navigate("/dashboard");
                          }
                      } else {
                          setLoginErrorMessage(response.data.msg)
                      }
                  }).catch((err) => {
                      const errorMessage = "Error while login. Reason: ";
                      logError(errorMessage, err.message);
                  })
              } else {
                  setInvalidPassword(true)
                  setOldPassword("")
                  setNewPassword("")
                  setConfirmPassword("")
              }
          })

      } catch (errors) {
          let dataErrors = {};
          errors.inner.forEach((element) => {
              if(!dataErrors[element.path]) {
                  dataErrors[element.path] = [];
              }
              dataErrors[element.path].push(element.message);
          });
          setErrors(dataErrors);
      }
  }

    const handleTimeZoneSelect = (event) => {
        var selectedZone = event.value;
        setSelectedTimeZone(selectedZone);
      };
  
      const handleLocaleSelect = (event) => {
        var selectedLocale = event.value;
        setSelectedLocale(selectedLocale);
      };
  
  
  
    useEffect( ()=>{
  
      provisioningApiGetRequest(APIUrls.GET_UNAUTH_LOCALES_LIST,ssoUserEmail).then((res) => {
            var options = [];
            res.data.data.map((lang) =>
              options.push({
                label: lang.display,
                value: lang
              })
            );
            setLocales(options);
      });
  
      provisioningApiGetRequest(APIUrls.GET_UNAUTH_TIMEZONE_LIST,ssoUserEmail).then((res) => {
            var options = [];
            res.data.data.map((zone) =>
                options.push({
                  label: zone.localizedName,
                  value: zone
                })
            );
            setTimeZones(options);
      });
    },[])
  

  return (
<div className="wrapper">
      <div className="sign-page">
        <div className="content">
          <div className="back" >
            <button type="button" onClick={navigateToLogin}>
              <i aria-hidden="true"></i>Back
            </button>
          </div>
          <div className="small-container">
            <div className="logo-block">
              <Link to="/">
                <img src={icons.OPAL_LOGO} alt="Logo" />
              </Link>
            </div>
            {errorMessage===""?
            <div className={!status?"inner-content-wrap update-password ":"hide"}>
              <h1> Change Password </h1>
              <form onSubmit={onFormSubmit} name="passwordManagementForm" commandName="passwordManagement">
                <div className="wrap-form">
                    <div className="input-group">
                {invalidPassord?<p className="textDanger">{Constants.INVALID_PASSWORD}</p>:Constants.BLANK}
                        <input
                        type="Password"
                        id="currPass"
                        className="form-control"
                        placeholder="Current Password"
                        aria-required="true"
                        name="curr-password"
                        autoComplete="off"
                        maxLength="64"
                        value={oldPassword}
                        onChange={currentPassword}
                        ref={focusRef}
                        aria-describedby="currentPassword"
                        />
                        {incorrectOldPassword && <p id="currentPassword" className="error-alert m-0 align-left" aria-label={incorrectOldPassword}>
                            {incorrectOldPassword}
                        </p>}
                        {errors?.currentPassword?.map((error) => (
                            <p id="currentPasswordError" className="error-alert m-0 align-left">
                                {error}
                            </p>
                        ))}
                    </div>
                  <div className="input-group">
                    <input
                      type="Password"
                      id="newPass"
                      className="form-control"
                      placeholder="New password"
                      aria-required="true"
                      aria-describedby="strenghtMsg"
                      name="password"
                      autoComplete="off"
                      maxLength="64"
                      value={newPassword}
                      onChange={passwordCheck}
                    />
                      {errors?.password?.map((error) => (
                          <p id="passwordError" className="error-alert m-0 align-left">
                              {error}
                          </p>
                      ))}
                    <div className={strongPassword?"pass-strength-success":"hide"}>
                      Strong
                    </div>
                    <div className={weakPasswordStatus?"pass-strength-success":"hide"}>
                      Weak
                    </div>
                    <div aria-label="Password instructions" className="instruction">
                        Must have at least 8 characters, 1 number, and 1 letter.
                    </div>
                  </div>
                  <div className="input-group">
                    <input
                      type="Password"
                      className="form-control"
                      placeholder="Confirm new password"
                      aria-required="true"
                      name="confirmPassword"
                      maxLength="64"
                      autoComplete="off"
                      onChange={isVerifyPassword}
                      aria-describedby="confirmPass"
                      value={confirmPassword}
                    />

                    {errors?.confirmPassword?.map((error) => (
                       <p id="confirmPasswordError" className="error-alert m-0 align-left">
                          {error}
                       </p>
                    ))}
                    </div>
                    <div className="wrap-form align-left wrap-sameHeight">
                        <div className="global-dropdown-block mar-bot25">
                          <Select classNamePrefix='cw'
                              className="global-dropdown-select w-d100"
                              placeholder="Select Locale"
                              aria-label="Locale"
                              options={locales}
                              value={locales.filter(function (option) {
                                return option?.value?.value === selectedLocale?.value;
                              })}
                              onChange={(e) => handleLocaleSelect(e)}
                              menuShouldScrollIntoView={false}
                              closeMenuOnSelect={true} 
                          />
                        </div>

                        <div className="global-dropdown-block mar-bot25">
                            <Select classNamePrefix='cw'
                              className="global-dropdown-select w-d100"
                              placeholder="Select Timezone"
                              aria-label="Timezone"
                              value={timeZones.filter(function (option) {
                                return option?.value?.id === selectedTimeZone?.id;
                              })}
                              options={timeZones}
                              onChange={(e) => handleTimeZoneSelect(e)}
                              menuShouldScrollIntoView={false}
                              closeMenuOnSelect={true} 
                          />
                        </div>

                      </div>
                    <div className="stricy-btn flex flex-center no-rightlist justify-end">
                        <div className="left flex">
                            <button id="change-pass" className="blue-btn" type="submit">
                                Save
                            </button>
                            <button className="blue-btn" onClick={navigateToLogin}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
              </form>
            </div>:<div><p>{errorMessage} <Link to={"/forgot-password"}>Click here</Link></p>  </div>}
          </div>
        </div>
      </div>
    </div>
  )
}
